import React from 'react';

/**
 * Rooney's Barber & Style logo component.
 * Replaces the lucide-react Scissors icon throughout the app.
 *
 * variants:
 *  - "icon-dark"  : scissors-only, black (for light backgrounds)
 *  - "icon-light" : scissors-only, white (for dark backgrounds)
 *  - "full-dark"  : full logo w/ text, black
 *  - "full-light" : full logo w/ text, white
 */
export const Logo = ({
  variant = 'icon-dark',
  className = '',
  alt = "Rooney's Barber & Style",
}) => {
  const src = {
    'icon-dark': '/rooneys-logo-icon.png',
    'icon-light': '/rooneys-logo-icon-white.png',
    'full-dark': '/rooneys-logo-full.png',
    'full-light': '/rooneys-logo-full-white.png',
  }[variant];

  return <img src={src} alt={alt} className={className} />;
};

export default Logo;
